import { $, $$ } from 'utils/dom';
import MobileAccordion from 'modules/mobile-accordion';
import Tabs from 'modules/tabs';

// for mobile and tablet: init accordions
const tabTeaserAccordionContainer = $$('.tab-teaser__content--mobile');
tabTeaserAccordionContainer.length &&
  tabTeaserAccordionContainer.forEach(container => {
    const tabTeaserAccordions = $$('.tab-teaser__accordion', container);
    tabTeaserAccordions.forEach(accordion => {
      new MobileAccordion({
        container: accordion,
        handler: $('.tab-teaser__accordion-toggle', accordion),
        target: $('.tab-teaser__accordion-content', accordion),
        showFirst: true, // open first accordion on init
        accordions: tabTeaserAccordions,
        breakpoint: 1200,
      }).init();
    });
  });

// for desktop: init tablist
const tabTeaserTabContainer = $$('.tab-teaser__content--desktop');
tabTeaserTabContainer.length &&
  tabTeaserTabContainer.forEach(container => {
    new Tabs(container, {
      tabNav: $('.tab-teaser__list', container), // container of you tab-navigation
      tabButton: $$('.tab-teaser__tab-toggle', container), // array of all your tab-buttons
      tabPanel: $$('.tab-teaser__tabpanel', container), // array of all your panels
      tabHeader: $('h3', container), // First element in your panel (like a title), relevant for screenreaders
      showRandom: container.dataset.show === 'random', // show random tab on init
      showFirst: container.dataset.show === 'first',
    }).init();
  });
